import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { getSharedRevision, replySharedRevision } from "@/lib/api";
import RevisionPublicSheet from "@/components/RevisionPublicSheet";

export default function RevisionPublicSharePage() {
  const { shareId } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const loadData = useCallback(async () => {
    if (!shareId) return;
    setLoading(true);
    try {
      const res = await getSharedRevision(shareId);
      setData(res);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Enlace no válido");
    } finally {
      setLoading(false);
    }
  }, [shareId]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <RevisionPublicSheet
      data={data}
      initialLoading={loading && !data}
      onReload={loadData}
      submitReply={(payload) => replySharedRevision(shareId, payload)}
    />
  );
}
